export default "https://d1e6s5z4lzmgxx.cloudfront.net/6e52c691-29e3-4541-bed6-a97355993ecd/images/clips-icon.svg?1f1e6d491e2a92306193b5208a73a8f5";